import { Box } from "@mui/material";
import poster from "../images/launch-new-pcs.png"
import HardwarePage from "./HardwarePage";
import FurniturePage from "./FurniturePage";
import { Link } from 'react-router-dom';


const boxStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    justifyContent: 'center',
    marginRight: '40px'
};

function HomePage() {

    const productBarLinkStyle={
        textDecoration: 'none',
        color: 'black'
    }

    return (
        <Box className="HomePage" sx={boxStyle}>
            <img src={poster} alt="Poster" style={{ minHeight: '60%', maxHeight: '80%', padding: "5px" }} />
            <div style={{ marginBottom: '70px' }} />
            <Link className="productBarLink" to={"/furniture"} style={productBarLinkStyle}>
                <FurniturePage includeDetails={false} />
            </Link>
            <div style={{ marginBottom: '70px' }} />
            <Link className="productBarLink" to={"/it-hardware"}  style={productBarLinkStyle}>
                <HardwarePage includeDetails={false} />
            </Link>

        </Box>
    );
}

export default HomePage;